/* eslint-disable no-confusing-arrow */
import CommonApi from '../api/CommonApi';
import UserApi from '../api/UserApi';
import ClientQuoteApi from '../api/ClientQuoteApi';
import TargetApi from '../api/TargetApi';
import SubmissionApi from '../api/SubmissionApi';
import DocumentApi from '../api/DocumentApi';
import ConsumableOrderApi from '../api/ConsumableOrderApi';
import { isArray } from 'lodash';

export const objectTypes = {
  clientList: 'clientList',
  addressList: 'addressList',
  country: 'country',
  contract: 'contract',
  fleet: 'fleet',
  asset: 'asset',
  location: 'location',
  timezone: 'timeZone',
  role: 'role',
  division: 'division',
  divisionNameSearch: 'divisionNameSearch',
  sourceSystem: 'sourceSystem',
  client: 'client',
  project: 'project',
  masterData: 'masterData',
  nameValueSetDetail: 'nameValueSetDetail',
  translationSet: 'translationSet',
  clientQuotation: 'clientQuotation',
  hazardsMaterial: 'hazardsMaterial',
  dispatchedIn: 'dispatchedIn',
  priority: 'priority',
  dataSchema: 'dataSchema',
  target: 'target',
  targetDetail: 'targetDetail',
  eventTrigger: 'eventTrigger',
  eventTriggerTemplate: 'eventTriggerTemplate',
  actionStatus: 'actionStatus',
  actionType: 'actionType',
  user: 'user',
  masterDataItem: 'masterDataItem',
  manufacturer: 'manufacturer',
  manufacturerModel: 'manufacturerModel',
  actionOwner: 'actionOwner',
  contractOwner: 'contractOwner',
  grade: 'Grade',
  inspectionLocationType: 'inspectionLocationType',
  product: 'product',
  documentType: 'documentType',
  zone: 'zone',
  timeStampEvent: 'timeStampEvent',
  timestampEventCategory: 'timestampEventCategory',
  contractName: 'contractName',
  vesselName: 'vesselName',
  bunkeringCountry: 'bunkeringCountry',
  submissionType: 'submissionType',
  fuelSupplier: 'fuelSupplier',
  sampleStatus: 'sampleStatus',
  imoNumber: 'imoNumber',
  courierStatus: 'courierStatus',
  bunkeringPort: 'bunkeringPort',
  consumableOrderStatus: 'consumableOrderStatus',
  VfProducts: 'VfProducts',
  serviceProvider: 'serviceProvider',
  fleetByContract: 'fleetByContract',
  assoicateVesselName: 'assoicateVesselName',
  sampleType: 'sampleType',
  sampleCategory: 'sampleCategory',
  addresses: 'addresses',
  ponumbers: 'ponumbers',
  sitelocation: 'sitelocation',
  screenAccess: 'screenAccess',
  scenarios: 'scenarios',
  supplyType: 'supplyType',
  materialType: 'materialType',
  volumeType: 'volumeType',
  depotLocation: 'depotLocation',
  orderStatus: 'orderStatus',
  preparationType: 'preparationType',
  orderRequestTemplate: 'orderRequestTemplate'
};

// const listEntryParamFactory = (text) => ({
//   ListDisplayValue: text,
// });

const dataSourceFetcherFactory = {
  [objectTypes.scenarios]: CommonApi.getScenariosAutoComplete,
  [objectTypes.addresses]: CommonApi.getAddressesAutoComplete,
  [objectTypes.ponumbers]: CommonApi.getPONumbersAutoComplete,
  [objectTypes.sitelocation]: CommonApi.getSiteLocationsAutoComplete,
  [objectTypes.vesselName]: CommonApi.getAssetAutoComplete,
  [objectTypes.assoicateVesselName]: CommonApi.getAssetAutoComplete,
  [objectTypes.documentType]: DocumentApi.DocumentTypesAutoComplete,
  [objectTypes.contractName]: ConsumableOrderApi.contractNamesAutoComplete,
  [objectTypes.location]: CommonApi.searchLocations,
  [objectTypes.timezone]: CommonApi.searchMasterData,
  [objectTypes.role]: UserApi.searchRoles,
  [objectTypes.division]: CommonApi.getDivisionsdata,
  [objectTypes.sourceSystem]: CommonApi.getsourceSystemsSearch,
  [objectTypes.client]: CommonApi.fetchAllClients,
  [objectTypes.country]: CommonApi.getCountriesForAutocomplete,
  [objectTypes.contract]: CommonApi.getContractForAutocomplete,
  [objectTypes.fleet]: CommonApi.getFleetForAutocomplete,
  [objectTypes.fleetByContract]: CommonApi.getFleetsByContractIDs,
  [objectTypes.asset]: CommonApi.getAssetForAutocomplete,
  [objectTypes.project]: CommonApi.searchProject,
  [objectTypes.masterData]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.inspectionLocationType]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.product]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.nameValueSetDetail]: CommonApi.getNameValueSetDetails,
  [objectTypes.translationSet]: CommonApi.searchTranslationSet,
  [objectTypes.clientQuotation]: ClientQuoteApi.searchClientQuotes,
  [objectTypes.hazardsMaterial]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.grade]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.dispatchedIn]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.priority]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.dataSchema]: CommonApi.searchDataSchema,
  [objectTypes.target]: TargetApi.searchTarget,
  [objectTypes.targetDetail]: TargetApi.searchTargetDetails,
  [objectTypes.eventTrigger]: CommonApi.searchEventTrigger,
  [objectTypes.eventTriggerTemplate]: CommonApi.searchEventTriggerTemplate,
  [objectTypes.actionStatus]: CommonApi.searchByActionsStatus,
  [objectTypes.actionType]: CommonApi.searchByActionsType,
  [objectTypes.user]: UserApi.searchUser,
  [objectTypes.actionOwner]: UserApi.searchUserActionOwner,
  [objectTypes.contractOwner]: UserApi.searchUserContractOwners,
  [objectTypes.masterDataItem]: CommonApi.searchMasterDataItem,
  [objectTypes.manufacturer]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.divisionNameSearch]: CommonApi.getDivisionsSearch,
  [objectTypes.manufacturerModel]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.submissionTemplate]: SubmissionApi.searchSubmission,
  [objectTypes.zone]: CommonApi.searchZones,
  [objectTypes.timeStampEvent]: CommonApi.getTimeStampEventAutoComplete,
  [objectTypes.timestampEventCategory]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.bunkeringCountry]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.submissionType]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.fuelSupplier]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.sampleStatus]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.imoNumber]: CommonApi.getAssetAutoComplete,
  [objectTypes.courierStatus]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.contract]: CommonApi.searchContractForAutocomplete,
  [objectTypes.consumableOrderStatus]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.VfProducts]: CommonApi.getVfProducts,
  [objectTypes.serviceProvider]: CommonApi.getListEntries,
  [objectTypes.bunkeringPort]: CommonApi.searchMasterDataForAutoComplete,
  [objectTypes.sampleType]: CommonApi.searchSampleTypeAutoComplete,
  [objectTypes.sampleCategory]: CommonApi.searchSampleCategoryAutoComplete,
  [objectTypes.supplyType]: CommonApi.getListEntries,
  [objectTypes.materialType]: CommonApi.searchMasterDataItem,
  [objectTypes.volumeType]: CommonApi.getParentMasterDataItemID,
  [objectTypes.orderStatus]: CommonApi.getListEntries,
  [objectTypes.preparationType]: CommonApi.getListEntries,
  [objectTypes.orderRequestTemplate]: CommonApi.getOrderRequestTemplateAutoComplete

};

const filterParamsFactory = {
  [objectTypes.addresses]: (text, extraFilter) => ({
    // address: text,
    clientIds: extraFilter?.clientIds,
    divisionIds: extraFilter?.divisionIds,
    sourceSystemIds: extraFilter?.sourceSystemIds,
    addressType: extraFilter?.addressType,
  }),
  [objectTypes.scenarios]: (text, extraFilter) => ({
    clientIds: extraFilter?.clientIds,
    divisionIds: extraFilter?.divisionIds,
    sourceSystemIds: extraFilter?.sourceSystemIds,
    addressIds: extraFilter?.addressIds,
  }),
  [objectTypes.ponumbers]: (text, extraFilter) => ({
    clientIds: extraFilter?.clientIds,
    divisionIds: extraFilter?.divisionIds,
    sourceSystemIds: extraFilter?.sourceSystemIds,
  }),
  [objectTypes.sitelocation]: (text, extraFilter) => ({
    siteLocation: text,
    clientIds: extraFilter?.clientIds,
    divisionIds: extraFilter?.divisionIds,
    sourceSystemIds: extraFilter?.sourceSystemIds,
  }),
  [objectTypes.screenAccess]: (text, extraFilter) => ({
    // id: text,
    id: extraFilter?.selectedRole,
  }),
  [objectTypes.location]: (text, extraFilter) => ({
    locationName: text,
    sourceSystemIds: extraFilter?.sourceSystemIds,
    locationIds: extraFilter?.locationIds,
    sortBy: 'LocationName'
  }),
  [objectTypes.vesselName]: (text, extraFilter) => ({
    assetName: text,
    fleetIds: extraFilter?.FleetID || '',
    contractID: extraFilter?.contractID
  }),
  [objectTypes.assoicateVesselName]: (text, extraFilter) => ({
    assetName: text,
    fleetIds: extraFilter?.FleetID || '',
    contractID: extraFilter?.contractID || '',
    divisionId: extraFilter?.divisionId
  }),
  [objectTypes.timeStampEvent]: (text) => ({
    eventName: text }),
  // [objectTypes.zone]: (divisionIds) => listEntryParamFactory('Zone', divisionIds),
  [objectTypes.zone]: (text, extraFilter) => ({
    divisionIds: extraFilter?.divisionIds
  }),
  [objectTypes.timezone]: (text) => ({
    masterDataType: 'Timezone',
    masterDataName: text,
    sortBy: 'MDName',
  }),
  [objectTypes.role]: (text) => ({
    roleName: text,
    active: true,
    sortBy: 'RoleName',
  }),
  [objectTypes.client]: (text, { locationIds, sourceSystemIds }) => ({
    clientName: text,
    sortBy: 'ClientName',
    sourceSystemIds,
    locationIds,
  }),
  [objectTypes.project]: (text, extraFilter) => {
    let clientIds = null;
    let divisionIds = null;
    let sourceSystemIds = null;
    let projectIds = null;
    if (extraFilter != null) {
      clientIds = extraFilter.clientIds || null;
      divisionIds = extraFilter.divisionIds || null;
      sourceSystemIds = extraFilter.sourceSystemIds || null;
      projectIds = extraFilter.projectIds || null;
    }

    return {
      projectName: text,
      clientIds,
      divisionIds,
      sourceSystemIds,
      projectIds,
      sortBy: 'MDName',
    };
  },
  [objectTypes.sourceSystem]: (text, extraFilter) => ({
    sourceSystemName: text,
    sourceSystemNameOP: 'Contains',
    divisionIds: extraFilter?.divisionIds,
  }),
  [objectTypes.divisionNameSearch]: (text) => ({
    divisionName: text,
    divisionNameOP: 'Contains',
  }),
  [objectTypes.masterData]: (text, { mdTypeName, masterDataIds }) => ({
    masterDataType: mdTypeName,
    masterDataName: text,
    masterDataIds,
    sortBy: 'MDName',
  }),
  [objectTypes.nameValueSetDetail]: (text, extraFilter) => ({
    nameValueSetType: extraFilter?.nameValueSetType,
    nameValueSetDetailName: text,
    nameValueSetDetailNameOP: 'Contains',
  }),
  [objectTypes.translationSet]: (text) => ({
    TranslationSetName: text,
    TranslationSetNameOP: 'Contains',
  }),
  [objectTypes.clientQuotation]: (text) => ({
    contractNumber: text,
  }),
  [objectTypes.hazardsMaterial]: () => ({
    masterDataType: 'HazardMaterial',
    masterDataNameOP: 'Contains',
  }),
  [objectTypes.grade]: (text) => ({
    masterDataType: 'Grade',
    masterDataName: text,
    masterDataNameOP: 'Contains',
  }),
  [objectTypes.dispatchedIn]: () => ({
    masterDataType: 'SubDispatchType',
    masterDataNameOP: 'Contains',
  }),
  [objectTypes.priority]: () => ({
    masterDataType: 'SubPriority',
    masterDataNameOP: 'Contains',
  }),
  [objectTypes.inspectionLocationType]: () => ({
    masterDataType: 'InspectionLocationType',
    masterDataNameOP: 'Contains',
  }),
  [objectTypes.product]: (text) => ({
    masterDataType: 'Product',
    masterDataNameOP: 'Contains',
    masterDataName: text,
  }),
  [objectTypes.VfProducts]: (text, extraFilter) => ({
    masterDataType: extraFilter?.masterDataType,
    masterDataName: text,
    masterDataNameOP: 'Contains',
  }),
  [objectTypes.serviceProvider]: (text, extraFilter) => ({
    // masterDataType: extraFilter?.mdTypeName || 'ServiceProvider',
    // masterDataName: text,
    // masterDataNameOP: 'Contains',
    listName: extraFilter?.listName || 'ServiceProvider'
  }),
  [objectTypes.bunkeringPort]: (text) => ({
    masterDataType: 'Port',
    masterDataName: text,
    masterDataNameOP: 'Contains',
    sortBy: 'MDName',
  }),
  [objectTypes.consumableOrderStatus]: () => ({
    masterDataType: 'OrderStatus',
  }),
  [objectTypes.dataSchema]: (text, extraFilter) => ({
    dataSchemaName: text,
    sourceSystemIds: extraFilter?.sourceSystemIds,
  }),
  [objectTypes.target]: (text) => ({
    TargetName: text,
    TargetNameOP: 'Contains',
  }),
  [objectTypes.targetDetail]: (text, extraFilter) => ({
    TargetDetailName: text,
    TargetDetailNameOP: 'Contains',
    TargetID: extraFilter?.targetId,
  }),
  [objectTypes.eventTrigger]: (text) => ({
    TriggerName: text,
    TriggerNameOP: 'Contains',
  }),
  [objectTypes.eventTriggerTemplate]: (text, extraFilter) => ({
    TemplateName: text,
    TemplateNameOP: 'Contains',
    EventTriggerID: extraFilter?.eventTriggerId,
  }),
  [objectTypes.actionStatus]: (text, extraFilter) => ({
    actionStatusName: text,
    actionStatusNameOP: 'Contains',
    actionsIds: extraFilter?.actionsIds,
  }),
  [objectTypes.user]: (text,) => ({
    textValue: text,
    active: true,
    sortBy: 'FirstName',
  }),
  [objectTypes.actionOwner]: (text,) => ({
    name: text,
    active: true,
    sortBy: 'FirstName',
  }),
  [objectTypes.contractOwner]: (text,) => ({
    name: text,
    active: true,
    sortBy: 'FirstName',
  }),
  [objectTypes.masterDataItem]: (text, { mdID }) => ({
    MasterDataID: mdID,
    MasterDataItemName: text,
  }),
  [objectTypes.manufacturer]: () => ({
    masterDataType: 'Manufacturer',
    sortBy: 'MDName'
  }),
  [objectTypes.manufacturerModel]: () => ({
    masterDataType: 'ManufacturerModel',
    sortBy: 'MDName'
  }),
  [objectTypes.submissionTemplate]: (text, extraFilter) => ({
    TemplateName: text,
    IsTemplate: extraFilter?.IsTemplate,
    ClientIDs: extraFilter?.ClientIDs
  }),
  [objectTypes.country]: (text, extraFilter) => ({
    CountryName: text,
    divisionIds: extraFilter?.divisionIds,
  }),
  [objectTypes.sampleType]: (text, extraFilter) => ({
    sampleTypeName: text,
    divisionIds: extraFilter?.divisionIds,
  }),
  [objectTypes.sampleCategory]: (text, extraFilter) => ({
    sampleCategoryName: text,
    divisionIds: extraFilter?.divisionIds,
  }),
  [objectTypes.contract]: (text) => ({
    contractName: text,
  }),
  [objectTypes.fleet]: (text) => ({
    fleetName: text,
  }),
  [objectTypes.fleetByContract]: (text, extraFilter) => ({
    contractIDs: isArray(extraFilter?.contractIDs) ? extraFilter.contractIDs : [extraFilter.contractIDs],
  }),
  [objectTypes.asset]: (text) => ({
    assertName: text,
  }),
  [objectTypes.imoNumber]: (text) => ({
    imoNumber: text,
  }),
  [objectTypes.documentType]: (documentTypeName) => ({
    documentTypeName,
  }),
  [objectTypes.contractName]: (contractName) => ({
    contractName,
  }),
  [objectTypes.timestampEventCategory]: () => ({
    masterDataType: 'TimestampEventCategory',
    masterDataNameOP: 'Contains',
  }),
  [objectTypes.bunkeringCountry]: (text) => ({
    masterDataType: 'BunkeringCountry',
    masterDataName: text,
    masterDataNameOP: 'Contains',
  }),
  [objectTypes.submissionType]: (text) => ({
    masterDataType: 'WorkType',
    masterDataName: text,
  }),
  [objectTypes.fuelSupplier]: (text) => ({
    masterDataType: 'Supplier',
    masterDataName: text
  }),
  [objectTypes.sampleStatus]: (text) => ({
    masterDataType: 'SampleStatus',
    masterDataName: text
  }),
  [objectTypes.courierStatus]: () => ({
    masterDataType: 'CourierStatus'
  }),
  [objectTypes.supplyType]: (text, extraFilter) => ({
    listName: extraFilter?.listName || 'SupplyType',
  }),
  [objectTypes.orderStatus]: (text, extraFilter) => ({
    listName: extraFilter?.listName || 'OrderStatus',
  }),
  [objectTypes.materialType]: (text, { TypeListEntryName }) => ({
    TypeListEntryName,
  }),
  [objectTypes.volumeType]: (text, { mdItemID }) => ({
    mdItemID,
  }),
  [objectTypes.depotLocation]: (text, extraFilter) => ({
    locationName: extraFilter?.locationName
  }),
  [objectTypes.preparationType]: (text, extraFilter) => ({
    listName: extraFilter?.listName || 'Preparation',
  }),
};
const defaultTransformer = (data) =>
  data ? data.Data.map((x) => ({ id: x.ID, text: x.Text })) : [];

const dataSourceTransformationFactory = {
  [objectTypes.scenarios]: (data) =>
    data ? data.Data.map((x) => ({ id: x.MDID, text: x.MDName, masterDataItems: x.MasterDataItems })) : [],
  [objectTypes.screenAccess]: (data) =>
    data ? data.Functionalities.map((x) => ({ id: x.FunctionalityID, text: x.FunctionalityName })) : [],
  [objectTypes.sitelocation]: (data) =>
    data.Data.map((x) => ({ id: x.SiteLocationID, text: x.SiteLocationName })),
  [objectTypes.addresses]: (data) =>
    data.Data.map((x) => ({ id: x.AddressID, text: x.AddressName, sourceSystemRecordID: x.SourceSystemRecordID, facility: x.Facility })),
  [objectTypes.ponumbers]: (data) =>
    data.Data.map((x) => ({ id: x.PONumberID, text: x.PONumber })),
  [objectTypes.location]: (data) =>
    data.Data.map((x) => ({ id: x.LocationID, text: x.LocationName })),
  [objectTypes.country]: (data) =>
    data.Data.map((x) => ({ id: x.CountryCode, text: x.CountryName })),
  [objectTypes.contract]: (data) =>
    data.Data.map((x) => ({ id: x.ContractID, text: x.ContractName, active: x?.Active, startedOn: x?.StartedOn, endedOn: x?.EndedOn })),
  [objectTypes.fleet]: (data) =>
    data.Data.map((x) => ({ id: x.Id, text: x.Name })),
  [objectTypes.fleetByContract]: (data) =>
    data.map((x) => ({ id: x.FleetID, text: x.FleetName })),
  [objectTypes.asset]: (data) =>
    data.Data.map((x) => ({ id: x.AssetID, text: x.AssetName })),
  [objectTypes.imoNumber]: (data) =>
    data.Data.map((x) => ({ id: x.AssetID, text: x.AssetNo ?? `${x.AssetID}` })),
  [objectTypes.vesselName]: (data) =>
    data.Data.map((x) => ({ id: x.AssetID, text: x.AssetName ?? `${x.AssetID}` })),
  [objectTypes.product]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.VfProducts]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName, MDJson: x.MDJson, ...x })),
  [objectTypes.bunkeringPort]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.consumableOrderStatus]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.serviceProvider]: (data) =>
    data.map((x) => ({ id: x.ListEntryID, text: x.ListDisplayValue })),
  [objectTypes.timezone]: (data) =>
    data.Data.map((x) => ({ id: x.MDTextID, text: x.MDName })),
  [objectTypes.role]: (data) =>
    data.Data.map((x) => ({ id: x.RoleID, text: x.RoleName })),
  [objectTypes.client]: (data) =>
    data.Data.map((x) => ({ ...x, id: x.ClientID, text: x.ClientName })),
  [objectTypes.division]: (data) =>
    data.map((x) => ({ id: x.DivisionID, text: x.DivisionName })),
  [objectTypes.divisionNameSearch]: (data) =>
    data?.Data?.map((x) => ({ id: x.DivisionID, text: x.DivisionName })),
  [objectTypes.sourceSystem]: (data) =>
    data.Data.map((x) => ({ id: x.SourceSystemID, text: x.SourceSystemName })),
  [objectTypes.project]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.masterData]: (data) =>
    data.Data.map((x) => ({ ...x, id: x.MDID, text: x.MDName })),
  [objectTypes.nameValueSetDetail]: (data) =>
    data.Data.map((x) => ({ ...x, id: x.NameValueSetDetailName, text: x.Value1 })),
  [objectTypes.translationSet]: (data) =>
    data.Data.map((x) => ({
      id: x.TranslationSetID,
      text: x.TranslationSetName,
    })),
  [objectTypes.clientQuotation]: (data) =>
    data.Data.map((x) => ({ id: x.ClientQuoteID, text: x.ContractNumber })),
  [objectTypes.hazardsMaterial]: (data) => data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.grade]: (data) => data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.dispatchedIn]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.priority]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.dataSchema]: (data) =>
    data.Data.map((x) => ({ id: x.DataSchemaID, text: x.DataSchemaName })),
  [objectTypes.target]: (data) =>
    data.Data.map((x) => ({ id: x.TargetID, text: x.TargetName })),
  [objectTypes.targetDetail]: (data) =>
    data.Data.map((x) => ({ id: x.TargetDetailID, text: x.TargetDetailName })),
  [objectTypes.eventTrigger]: (data) =>
    data.Data.map((x) => ({ id: x.EventTriggerID, text: x.TriggerName })),
  [objectTypes.eventTriggerTemplate]: (data) =>
    data.Data.map((x) => ({
      id: x.EventTriggerTemplateID,
      text: x.TemplateName,
    })),
  [objectTypes.actionStatus]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.actionType]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.user]: (data) =>
    data.Data.map((x) => ({ id: x.UserID, text: `${x.FirstName} ${x.LastName}` })),
  [objectTypes.actionOwner]: (data) =>
    data.Data.map((x) => ({ id: x.UserID, text: x.FullName })),
  [objectTypes.contractOwner]: (data) =>
    data.Data.map((x) => ({ id: x.UserID, text: x.FullName })),
  [objectTypes.masterDataItem]: (data) =>
    data.Data.map((x) => ({ id: x.MDItemID, text: x.MDItemTextID })),
  [objectTypes.manufacturer]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.manufacturerModel]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.zone]: (data) =>
    data.map((x) => ({ id: x.ZoneID, text: x.ZoneName, divisionId: x.DivisionID })),
  [objectTypes.timeStampEvent]: (data) =>
    data.map((x) => ({ id: x.TimestampEventID, text: x.EventName })),
  [objectTypes.submissionTemplate]: (data) =>
    data.Data.map((x) => ({ id: x.SubmissionID, text: x.TemplateName || x.SubmissionID })),
  [objectTypes.documentType]: (data) =>
    data.Data.map((x) => ({ id: x.DocumentTypeID, text: x.DocumentTypeName })),
  [objectTypes.contractName]: (data) =>
    data.Data.map((x) => ({ id: x.ContractID, text: x.ContractName })),
  [objectTypes.timestampEventCategory]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.bunkeringCountry]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName?.length > 0 ? x.MDName : `${x.MDID}` })),
  [objectTypes.submissionType]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.fuelSupplier]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName?.length > 0 ? x.MDName : `${x.MDID}` })),
  [objectTypes.sampleStatus]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.courierStatus]: (data) =>
    data.Data.map((x) => ({ id: x.MDID, text: x.MDName })),
  [objectTypes.supplyType]: (data) =>
    data.map((x) => ({ id: x.ListEntryID, text: x.ListDisplayValue })),
  [objectTypes.orderStatus]: (data) =>
    data.map((x) => ({ id: x.ListEntryID, text: x.ListDisplayValue })),
  [objectTypes.materialType]: (data) =>
    data.Data.map((x) => ({ id: x.MDItemID, text: x.MDItemName })),
  [objectTypes.volumeType]: (data) =>
    data.map((x) => ({ id: x.MDItemID, text: x.MDItemName })),
  [objectTypes.depotLocation]: (data) =>
    data.Data.map((x) => ({ id: x.DepotLocationID, text: x.LocationName })),
  [objectTypes.preparationType]: (data) =>
    data.map((x) => ({ id: x.ListEntryID, text: x.ListDisplayValue })),
};

export const autoCompleteDataFetcher = async (
  url,
  objectType,
  pageSize = 20,
  page = 1,
  text = '',
  extraFilter
) => {
  let filterParams = {
    page,
    pageSize,
  };

  if (filterParamsFactory[objectType]) {
    filterParams = {
      ...filterParams,
      ...filterParamsFactory[objectType](text, extraFilter),
    };
  }

  const fetcher = dataSourceFetcherFactory[objectType];
  if (fetcher) {
    const data = await fetcher(filterParams);
    const transformer =
      dataSourceTransformationFactory[objectType] ?? defaultTransformer;
    // console.log('Fetched data: ', data);
    const transformedData = transformer(data) ?? [];
    // console.log('Transformed data: ', transformedData);
    return transformedData;
  }

  return [];
};
